






































import { defineComponent, PropType, toRefs, ref, watch } from '@vue/composition-api';
import PopupTree from './popup-tree.vue';
import * as tool from './../../../utils/tree-utils';
import { ITreeOption } from './const/fastCreation';

const name = 'ttam-tree-compose';
export default defineComponent({
  name,
  components: {
    PopupTree,
  },
  emits: ['tree-map', 'input', 'change', 'update-tree-value'],
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Array as PropType<string[] | number[]>,
      default: () => [],
    },
    options: {
      type: Array as PropType<ITreeOption[]>,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    flatMode: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const show = ref(false);
    const { value, options, disabled: disabledRef, flatMode } = toRefs(props);

    function generateTreeNodesMap() {
      const result = {};
      const root = { children: options.value };

      tool.walkTreeBFS({
        root,
        handler(node) {
          if (tool.isDef(node.value)) {
            result[node.value] = node;
            (node.children || []).forEach(child => {
              child.parentId = node.value; // 父节点id
            });
          }
        },
      });
      emit('tree-map', result);
      return result;
    }
    const treeNodesMap = generateTreeNodesMap();

    const getLabelByValue = (_value): void => {
      if (!_value) {
        return _value;
      }
      const node = treeNodesMap[_value];
      if (node) {
        return node.label || _value;
      }
      return _value;
    };
    const label = (): string => value.value.map(item => getLabelByValue(item)).join(' / ');

    const label_watcher = ref(label());
    watch(
      () => props.value,
      () => {
        label_watcher.value = value.value.map(item => getLabelByValue(item)).join(' / ');
      },
    );

    const handleClick = (): void => {
      if (disabledRef.value) {
        return;
      }
      show.value = true;
    };

    const handleConfirm = (values: any): void => {
      console.log('inside handleConfirm of tree-compose of ttam-ui with values: ', values);
      if (flatMode.value) {
        emit('input', values);
        emit('change', values);
      } else {
        emit('update-tree-value', values);
      }
    };

    const handleClose = (): void => {
      show.value = false;
    };
    return {
      name,
      show,
      label: label_watcher,
      handleClick,
      handleConfirm,
      handleClose,
      treeNodesMap,
    };
  },
});
